import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Icon } from '../icon/icon.component.js';
import { Text } from '../text/text.component.js';
import { Wrapper, HeaderContainer, IconContainer, Body, IndividualContainer, QuestionBody, FaqControlIcon } from './faq-component.style.js';
import { transformData } from './faq-component.utils.js';

const FaqComponent = ({ data, header = 'Frequently Asked Questions', }) => {
    const [toggleInfo, setToogleInfo] = useState(transformData(data));
    const toggleFaq = (name) => {
        const updatedData = Object.assign({}, toggleInfo);
        Object.keys(updatedData).forEach(key => {
            if (key === name)
                updatedData[key] = !updatedData[key];
            else
                updatedData[key] = false;
        });
        setToogleInfo(updatedData);
    };
    return (jsxs(Wrapper, { children: [jsxs(HeaderContainer, { children: [jsx(IconContainer, { children: jsx(Icon, { icon: "QuestionCircleInverted", scale: 2 }, void 0) }, void 0), jsx(Text, Object.assign({ textStyle: "heading600" }, { children: header }), void 0)] }, void 0), jsx(Body, { children: data.map(d => {
                    return (jsxs(IndividualContainer, { children: [jsxs(QuestionBody, { children: [jsx(Text, Object.assign({ textStyle: "paragraph600", tag: "h6" }, { children: d.question }), void 0), jsx(FaqControlIcon, Object.assign({ onClick: () => toggleFaq(d.name) }, { children: toggleInfo[d.name] ? (jsx(Icon, { icon: "Minus", scale: 2, "data-testid": `faq-control-icon-minus-${d.name}` }, void 0)) : (jsx(Icon, { icon: "Plus", scale: 2, "data-testid": `faq-control-icon-plus-${d.name}` }, void 0)) }), void 0)] }, void 0), toggleInfo[d.name] && jsx("div", { children: d.answer }, void 0)] }, d.name));
                }) }, void 0)] }, void 0));
};

export { FaqComponent };
